import { gql } from '@apollo/client';

/**
 * 保存审核池条目的联系结果草稿（2.1 需求点1）。
 *
 * <p>四项**整体覆盖**：不传 / 传空即清空该项。所以每次都要把当前完整状态发上去，
 * 不能只发变化的那一项 —— 后端不做部分更新（否则运营"取消勾选 / 清空截图"会变成"不更新"，
 * 界面清了库里还留着，下次进来又被恢复出来）。
 */
export const SAVE_REVIEW_POOL_CONTACT_DRAFT = gql`
  mutation SaveReviewPoolContactDraft($input: SaveReviewPoolContactDraftInput!) {
    saveReviewPoolContactDraft(input: $input)
  }
`;

export interface SaveReviewPoolContactDraftInput {
  reviewPoolId: number;
  /** 1 已联系到 / 2 未联系到；不传 = 清空 */
  contactResult?: number;
  proofS3Keys?: string[];
  secondContactResult?: number;
  secondProofS3Keys?: string[];
}

export interface SaveReviewPoolContactDraftResponse {
  saveReviewPoolContactDraft: boolean;
}
